import { post } from '@namespace/helpers';

type ReturnType = {
  data: { prize_id: string; spinAt: Date };
  status: 'success' | 'error';
};

export const postSpinWheel = (currency: string) =>
  post<ReturnType>('/service/wheel-of-fortune/wheel-of-fortune/v1/spin', {
    currency
  })
    .then(({ data, status }) => {
      return { prizeId: data.prize_id, status };
    })
    .catch((e: ReturnType) => {
      return e;
    });
